import React from "react";
import { Icon, useTheme } from "@fluentui/react";
// Controls
import { AIDisclaimerAndFeedbackV9 } from "../AIDisclaimerAndFeedback/AIDisclaimerAndFeedback";
import { useLoggers } from "../../../hooks/useLoggers";
// Constants
import { EngagementTelemetryConstants } from "@ms/uno-constants/lib/local/EngagementTelemetryConstants";
import { CopilotFeatureName } from "@ms/uno-constants/lib/local/CopilotConstants";
import { OcvFeatureAreas } from "@ms/uno-constants/lib/local/OCVConstants";
// Styles
import { getStyles, getClassNames } from "./AIGeneratedTaskSection.styles";
/**
 * AIGeneratedTaskSection
 * This component displays an icon, relevant message, and a feedback section.
 * It is used to show AI-generated task info in task editor and allows users to provide feedback.
 */ export const AIGeneratedTaskSection = ({ icon, primaryText, secondaryText, taskId, tenantFeedbackSettings, appContext })=>{
    const theme = useTheme();
    const styles = getStyles(theme);
    const classNames = getClassNames(styles);
    const loggers = useLoggers();
    const onLogLikeDislike = (isPositive)=>{
        loggers.engagementLogger.logEngagement(EngagementTelemetryConstants.AIGeneratedTaskSection, isPositive ? EngagementTelemetryConstants.CopilotResultLiked : EngagementTelemetryConstants.CopilotResultDisliked, {
            taskId: taskId
        });
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "AIGeneratedTaskSection"
    }, /*#__PURE__*/ React.createElement("div", {
        className: classNames.root
    }, /*#__PURE__*/ React.createElement("div", {
        className: classNames.topRow
    }, /*#__PURE__*/ React.createElement("div", {
        className: classNames.icon
    }, /*#__PURE__*/ React.createElement(Icon, icon)), /*#__PURE__*/ React.createElement("div", {
        className: classNames.textWrapper
    }, /*#__PURE__*/ React.createElement("div", {
        className: classNames.primaryText
    }, primaryText), /*#__PURE__*/ React.createElement("div", {
        className: classNames.secondaryText
    }, secondaryText))), /*#__PURE__*/ React.createElement("div", {
        className: classNames.feedbackWrapper
    }, /*#__PURE__*/ React.createElement(AIDisclaimerAndFeedbackV9, {
        idPrefix: "AIGeneratedTaskSection-",
        tenantFeedbackSettings: tenantFeedbackSettings,
        onLogLikeDislike: onLogLikeDislike,
        context: appContext,
        feedbackFeatureArea: OcvFeatureAreas.GsdInBasicPlansFeedback,
        feedbackFeatureName: CopilotFeatureName.PlanGeneration
    }))));
};
